import { createSlice } from '@reduxjs/toolkit';

import { updateStatusType } from '@/constants';
import type { Map } from '@/types/maps';

const initialState: Map = {
  center: [0, 0],
  isEnabledDrawer: false,
  isEnabledMap: false,
  isEnabledPermitted: false,
  currentLocation: {
    latitude: 0,
    longitude: 0,
  },
  position: {
    latitude: 0,
    longitude: 0,
  },
  centralCoordinateLocationPermitted: {
    latitude: 0,
    longitude: 0,
  },
  maxZoom: 0,
  minZoom: 0,
  zoom: 0,
  bearing: 0,
  pitch: 0,
  isLoadedOverlay: false,
  isErrorCanal: false,
  updateStatus: updateStatusType.IDLE,
  hasBell: false,
  hasHighInforMation: false,
  movementTracks: [],
  spotRouteGuidePoints: {
    startPoint: undefined,
    spotPoint: undefined,
  },
  centerSpotId: '',
  showLabelSpotIds: [],
  nonClusterSpotIds: [],
  isMapSwiping: false,
  isEnabledHighOrMiddleInformation: false,
  isAdminSignedInInformationConfirmed: false,
  enableMapTypes: [],
};

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    changePosition: (state, action) => {
      state.position.latitude = action.payload.latitude;
      state.position.longitude = action.payload.longitude;
    },
    changeCurrentLocation: (state, action) => {
      state.currentLocation.latitude = action.payload.latitude;
      state.currentLocation.longitude = action.payload.longitude;
    },
    changeCentralCoordinateLocationPermitted: (state, action) => {
      state.centralCoordinateLocationPermitted.latitude =
        action.payload.latitude;
      state.centralCoordinateLocationPermitted.longitude =
        action.payload.longitude;
    },
    changeIsPermitted: (state, action) => {
      state.isEnabledPermitted = action.payload;
    },
    changeIsLoadedOverlay: (state, action) => {
      state.isLoadedOverlay = action.payload;
    },
    changeUpdateStatus: (state, action) => {
      state.updateStatus = action.payload;
    },
    changeIsEnabledMap: (state, action) => {
      state.isEnabledMap = action.payload;
    },
    changeMaxZoom: (state, action) => {
      state.maxZoom = action.payload;
    },
    changeMinZoom: (state, action) => {
      state.minZoom = action.payload;
    },
    changeZoom: (state, action) => {
      state.zoom = action.payload;
    },
    changeIsErrorCanal: (state, action) => {
      state.isErrorCanal = action.payload;
    },
    changeBearing: (state, action) => {
      state.bearing = action.payload;
    },
    changePitch: (state, action) => {
      state.pitch = action.payload;
    },
    changeHasBell: (state, action) => {
      state.hasBell = action.payload;
    },
    changeHasHighInforMation: (state, action) => {
      state.hasHighInforMation = action.payload;
    },
    setMovementTracks: (state, action) => {
      state.movementTracks = action.payload;
    },
    setSpotRouteGuidePoints: (state, action) => {
      state.spotRouteGuidePoints = action.payload;
    },
    setCenterSpotId: (state, action) => {
      state.centerSpotId = action.payload;
    },
    setShowLabelSpotIds: (state, action) => {
      state.showLabelSpotIds = action.payload;
    },
    setNonClusterSpotIds: (state, action) => {
      state.nonClusterSpotIds = action.payload;
    },
    setMapSwiping: (state, action) => {
      state.isMapSwiping = action.payload;
    },
    setEnabledHighOrMiddleInformation: (state, action) => {
      state.isEnabledHighOrMiddleInformation = action.payload;
    },
    setIsAdminSignedInInformationConfirmed: (state, action) => {
      state.isAdminSignedInInformationConfirmed = action.payload;
    },
    setEnableMapTypes: (state, action) => {
      state.enableMapTypes = action.payload;
    },
  },
});

export const {
  reducer: mapReducer,
  actions: {
    changePosition,
    changeCurrentLocation,
    changeCentralCoordinateLocationPermitted,
    changeIsPermitted,
    changeIsLoadedOverlay,
    changeUpdateStatus,
    changeIsEnabledMap,
    changeMaxZoom,
    changeMinZoom,
    changeZoom,
    changeIsErrorCanal,
    changeBearing,
    changePitch,
    changeHasBell,
    changeHasHighInforMation,
    setMovementTracks,
    setSpotRouteGuidePoints,
    setCenterSpotId,
    setShowLabelSpotIds,
    setNonClusterSpotIds,
    setMapSwiping,
    setEnabledHighOrMiddleInformation,
    setIsAdminSignedInInformationConfirmed,
    setEnableMapTypes,
  },
} = mapSlice;
